<script>
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";
export default {
  name: "ProfilePoliticianInfoItem",
  components: {
    BaseAvatar
  },
  props: {
    itemData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    forum() {
      return this.itemData.forum || this.itemData.election.forum;
    },
    party() {
      return this.itemData.party;
    },
    startDate() {
      return this.itemData.termStart || this.itemData.election.termStart;
    },
    endDate() {
      return this.itemData.termEnd || this.itemData.election.termEnd;
    },
    forumIconSrc() {
      return `/viewimage?type=forum&sh=${this.forum.imgHash}`;
    },
    partyIconSrc() {
      return `/viewimage?type=forum&sh=${this.itemData.party.imgHash}`;
    },
  },
}
</script>

<template>
<div class="politician-item">
  <base-avatar :img-src="forumIconSrc"
               size="36"
               v-tooltip.top="forum.name"
               class="politician-item__forum-icon"
  />
  <div class="politician-item__info">
    <span class="politician-item__forum-name">{{forum.name}}</span>
    <div v-if="party" class="position-relative">
      <span class="politician-item__party-name">
        {{itemData.party.name}}
      </span>
      <base-avatar :img-src="partyIconSrc"
                   :size="'SM'"
                   v-tooltip.top="party.name"
                   class="politician-item__party-icon"
      />
    </div>
  </div>
  <div class="politician-item__period-wrap">
    <div :class="{'disabled': !itemData.active}"
         class="politician-item__period"
    >
      {{startDate}} - {{endDate}}
    </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.politician-item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 12px;
  height: 48px;
  font-size: 16px;
  &:after {
    content: "";
    position: absolute;
    left: 29px;
    top: 43px;
    height: 12px;
    width: 2px;
    background: #bbbbbb;
  }
  &__forum-icon{
    margin-right: 10px;
    position: relative;
  }
  &__info {
    display: flex;
    flex-direction: column;
    text-align: left;
    position: relative;
  }
  &__forum-name {
    font-size: 14px;
    font-weight: 600;
    color: #7835a6;
  }
  &__party-name {
    display: inline-block;
    max-width: 280px;
    font-size: 14px;
    font-weight: 600;
    color: #7b7b7b;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__party-icon {
    position: absolute;
    right: -27px;
    bottom: -2px;
  }
  &__period-wrap {
    width: 210px;
    min-width: 210px;
    display: flex;
    justify-content: center;
    margin-left: auto;
    position: relative;
    &:before {
      position: absolute;
      left: 0;
      display: block;
      content: '';
      width: 1px;
      height: 24px;
      background-color: #d1d1d1;
    }
  }
  &__period {
    height: fit-content;
    padding: 5px 9px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background: #7835a6;
    border-radius: 18px;
    &.disabled {
      background: #bbbbbb;
    }
  }
}








</style>